// extracted by mini-css-extract-plugin
export default {"errorMessage":"UHZaI__errorMessage","errorIcon":"GoHoz__errorIcon","errorMessageWrapper":"NFg8b__errorMessageWrapper","message":"i58Tc__message"};